/* globals OptimizeSuite */

'use strict';

const trackingHubAdd = (name, data) =>
  OptimizeSuite.TrackingHub.add(name, data);

module.exports = trackingHubAdd;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/tracking_hub_add.js